import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Buildings } from '@app/energy-guard/models/buildings';
import { ConsumersService } from '@app/shared/services/api/consumers.service';
import { UserService } from '@app/shared/services/api/user.service';
import { User } from '@app/shared/models/user';
import { UserMunicipalitiesService } from '@app/shared/services/user-municipalities.service';
import { get, isNil } from 'lodash';
import { forkJoin, of, Subject, throwError } from 'rxjs';
import { catchError, filter, finalize, switchMap, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-building-history-dialog',
  templateUrl: './building-history-dialog.component.html',
  styleUrls: ['./building-history-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class BuildingHistoryDialogComponent implements OnInit, OnDestroy {
  protected buildingHistoryDialogUnsubscribe$: Subject<void> = new Subject<void>();

  public userData: User = {} as User;
  public buildingData: Buildings[] = [];
  public isSaving = false;

  constructor(
    private userService: UserService,
    private consumerService: ConsumersService,
    private userMunicipalityService: UserMunicipalitiesService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  public ngOnInit(): void {
    this.showHistory();
  }

  public ngOnDestroy(): void {
    this.buildingHistoryDialogUnsubscribe$.next();
    this.buildingHistoryDialogUnsubscribe$.complete();
  }

  private showHistory(): void {
    if (this.data.buildingId) {
      this.isSaving = true;
      this.consumerService
        .getByGuid(this.data.buildingId, this.userMunicipalityService.currentMunicipality.key)
        .pipe(
          filter((building: Buildings[]) => building.length > 0 && !isNil(building[0].gpsModifiedBy)),
          switchMap((building: Buildings[]) => {
            if (building[0].gpsModifiedBy.toString().includes('-')) {
              return forkJoin([of(building), this.userService.getByUserGuid(building[0].gpsModifiedBy).pipe(catchError(() => of({} as User)))]);
            } else {
              return forkJoin([of(building), this.userService.getByUserId(building[0].gpsModifiedBy).pipe(catchError(() => of({} as User)))]);
            }
          }),
          catchError((e: Error | HttpErrorResponse) => {
            // TODO: move to app insight logging
            // console.error(e);
            return throwError(() => e);
          }),
          takeUntil(this.buildingHistoryDialogUnsubscribe$),
          finalize(() => (this.isSaving = false))
        )
        .subscribe(([building, user]: [Buildings[], User]) => {
          this.buildingData = building;
          this.userData = user;
        });
    }
  }

  public getProp(obj: any, prop: string): string {
    return get(obj, prop) || '';
  }
}
